import React from "react";
import { Link } from "react-router-dom";

const EmptyState = ({ title, text, actionText, actionTo, secondaryText, secondaryTo, icon = "la la-info-circle" }) => {
  return (
    <div className="epic-empty-state">
      <span className="epic-empty-icon"><i className={icon}></i></span>
      <h4>{title}</h4>
      {text && <p>{text}</p>}
      {(actionText || secondaryText) && (
        <div className="epic-empty-actions">
          {actionText && actionTo && <Link to={actionTo} className="theme-btn btn-style-one">{actionText}</Link>}
          {secondaryText && secondaryTo && <Link to={secondaryTo} className="theme-btn btn-style-three">{secondaryText}</Link>}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
